module.exports = __webpack_public_path__ + "dingbeauty-build/img/3@2.192e0898.jpg";